export function createSatellitePkg(name) {
  return {
    path: 'satellite_packages',
    method: 'POST',
    body: JSON.stringify({ name }),
  };
}

export function deleteSatellitePkg(id) {
  return {
    path: `satellite_packages/${id}`,
    method: 'DELETE',
  };
}

export function getSatellitePkg(id) {
  return { path: `satellite_packages/${id}` };
}

export function searchSatellitePkgs(query) {
  return { path: `satellite_packages${query}` };
}

export function updateSatellitePkg(id, newName) {
  return {
    path: `satellite_packages/${id}`,
    method: 'PUT',
    body: JSON.stringify({ name: newName }),
  };
}
